import { useEffect, useState } from "react";

const MAP_SRC = "https://maps.google.com/maps?q=Nottingham,UK&z=9&output=embed";
const GBP_URL = "https://maps.google.com/?cid=4748127638390652358";

export default function ServiceAreaMap({
  title = "Mids Tuning service area map — Nottingham, Derby & East Midlands",
  className = "",
}) {
  const [loaded, setLoaded] = useState(false);
  const [slow, setSlow] = useState(false);

  // If the embed hasn't painted within 6s (slow mobile data, blocked
  // third-party frames), show a usable fallback instead of "Loading…".
  useEffect(() => {
    if (loaded) return undefined;
    const t = setTimeout(() => setSlow(true), 6000);
    return () => clearTimeout(t);
  }, [loaded]);

  return (
    <div className={`relative border border-white/10 bg-surface-1 overflow-hidden ${className}`} data-testid="service-area-map">
      {!loaded && (
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 text-center px-6" data-testid="service-area-map-fallback">
          <div className="font-display uppercase text-lg md:text-xl">Nottingham · Derby · East Midlands</div>
          <div className="font-mono text-[10px] uppercase tracking-widest text-white/40">
            {slow ? "Map not loading on this connection" : "Loading map…"}
          </div>
          <a href={GBP_URL} target="_blank" rel="noopener noreferrer" className="font-mono text-[11px] uppercase tracking-widest text-volt hover:text-white transition-colors">
            Open Mids Tuning on Google Maps →
          </a>
        </div>
      )}
      <iframe
        src={MAP_SRC}
        title={title}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        onLoad={() => setLoaded(true)}
        className={`w-full h-[320px] md:h-[420px] grayscale invert-[0.92] contrast-[0.9] transition-opacity duration-500 ${loaded ? "opacity-90" : "opacity-0"}`}
        allowFullScreen
      />
    </div>
  );
}
